import { Text } from 'blaze-ui/Text/Text'
import { Input } from 'almanac-ui/TextInputField/Input'
import Skeleton from 'components/Skeleton/Skeleton'
import { SourceMaterialAnalysis } from 'types'
import Styles from './AddContext.module.scss'

interface SourceAnalysisBodyProps {
  isPending: boolean
  analysis: SourceMaterialAnalysis | null
}

/**
 * The analysis area of a SourceCard: while polling we show a loader, and once it
 * stops we show the analysis summary, or a failed state if none was produced.
 */
export const SourceAnalysisBody = ({ isPending, analysis }: SourceAnalysisBodyProps) => {
  if (isPending) {
    return (
      <div className={Styles.analysisPending}>
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </div>
    )
  }

  if (analysis) {
    return (
      <div className={Styles.analysisSummary}>
        <Input
          name="analysis-summary"
          className={Styles.analysisSummary}
          isTextarea
          readOnly
          value={analysis.summary ?? ''}
        />
      </div>
    )
  }

  return (
    <div className={Styles.analysisFailed}>
      <Text variant="metadata" color="var(--red-90)">
        We couldn&apos;t read this file, so it won&apos;t be used as context. Try a different file or remove it.
      </Text>
    </div>
  )
}
